import {useContext, useState} from 'react'
import {ListViewPageContext} from '../../context'
import CreateTicketModal from '../modals/CreateTicketModal'
import Search from '../../../../components/Search'
import {SideFilter} from '../../../../components/SideFilter'
import useSaveFilter from '../../../projectReports/hooks/useSaveFilter'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'

const ListViewPageHeader = () => {
  const [showModal, setShowModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const {
    hasListViewPermission,
    onSearch,
    refetchAgileBoardTicketList,
    filtersData,
    isLoadingAgileBoardTicketList,
    checkedRows,
    setCheckedRows,
    deleteTicket,
    isLoadingTicketOperation,
    projectName,
  } = useContext(ListViewPageContext)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const {isOperationLoading, onSaveFilter} = useSaveFilter(refetchAgileBoardTicketList)

  return (
    <div className='d-flex justify-content-between align-items-center mb-8'>
      <Search onSearch={onSearch} />
      <div>
        {hasListViewPermission && checkedRows?.length > 0 && (
          <button
            type='button'
            className='btn btn-danger align-self-end me-5'
            onClick={() => setShowDeleteModal(true)}
          >
            Delete
          </button>
        )}
        <SideFilter
          filterData={filtersData}
          onApply={onSaveFilter}
          isOperationLoading={isOperationLoading || isLoadingAgileBoardTicketList}
          onCancel={() => setIsDrawerOpen(false)}
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
          filterType={'project_list_view'}
        />
        {hasListViewPermission && (
          <button type='button' onClick={() => setShowModal(true)} className='btn btn-primary'>
            <i className='fa-solid fa-plus'></i>Create Ticket
          </button>
        )}
      </div>
      {hasListViewPermission && showModal && (
        <CreateTicketModal show={showModal} onClose={() => setShowModal(false)} />
      )}
      {hasListViewPermission && showDeleteModal && (
        <ConfirmationModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onAction={() => deleteTicket({card_ids: checkedRows}, setCheckedRows)}
          isDataLoading={isLoadingAgileBoardTicketList}
          isOperationLoading={isLoadingTicketOperation}
          body={
            <p>
              Do you really want to remove the selected tickets from the{' '}
              <strong>{projectName}</strong> project?
            </p>
          }
        />
      )}
    </div>
  )
}

export {ListViewPageHeader}
